import React from 'react';

/**
 * NCAA Basketball-themed decorative SVG overlays.
 * Six designs assigned to cards by index for visual variety.
 * All use currentColor for theme adaptation.
 */

/* 0 — Basketball */
function Basketball() {
    return (
        <svg viewBox="0 0 120 120" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
            <circle cx="60" cy="60" r="45" />
            <path d="M15 60h90" />
            <path d="M60 15v90" />
            <path d="M22 28c20 12 20 52 0 64" />
            <path d="M98 28c-20 12-20 52 0 64" />
        </svg>
    );
}

/* 1 — Hoop & Net */
function HoopNet() {
    return (
        <svg viewBox="0 0 120 120" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
            <ellipse cx="60" cy="38" rx="28" ry="6" />
            <path d="M32 38l8 40" />
            <path d="M88 38l-8 40" />
            <path d="M42 38l4 40" />
            <path d="M78 38l-4 40" />
            <path d="M60 44v36" />
            <path d="M36 52c8 4 16 4 24 0s16-4 24 0" />
            <path d="M38 64c8 4 14 4 22 0s14-4 22 0" />
        </svg>
    );
}

/* 2 — Backboard & Rim */
function Backboard() {
    return (
        <svg viewBox="0 0 120 120" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <rect x="20" y="12" width="80" height="56" rx="4" />
            <rect x="42" y="28" width="36" height="26" rx="2" />
            <ellipse cx="60" cy="78" rx="18" ry="4" />
            <line x1="60" y1="68" x2="60" y2="74" />
            <path d="M42 82l6 24" />
            <path d="M78 82l-6 24" />
            <path d="M52 82l2 24" />
            <path d="M68 82l-2 24" />
        </svg>
    );
}

/* 3 — Megaphone */
function Megaphone() {
    return (
        <svg viewBox="0 0 120 120" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 55l60-25v60L20 65z" />
            <rect x="8" y="52" width="14" height="16" rx="3" />
            <path d="M18 68l6 28h12l-4-28" />
            <path d="M88 42c8 6 8 30 0 36" />
            <path d="M96 34c12 10 12 42 0 52" />
        </svg>
    );
}

/* 4 — Trophy */
function Trophy() {
    return (
        <svg viewBox="0 0 120 120" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M38 18h44v32c0 16-10 28-22 28s-22-12-22-28z" />
            <path d="M38 28H24c0 16 8 24 14 26" />
            <path d="M82 28h14c0 16-8 24-14 26" />
            <line x1="60" y1="78" x2="60" y2="92" />
            <rect x="40" y="92" width="40" height="10" rx="3" />
            <path d="M50 24l4 8 8-2-4 8 6 6-8 2-2 8-6-6-8 2 2-8-6-6 8-2z" opacity="0.5" />
        </svg>
    );
}

/* 5 — Half-Court Lines */
function CourtLines() {
    return (
        <svg viewBox="0 0 120 120" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
            <rect x="8" y="8" width="104" height="104" rx="3" />
            <line x1="60" y1="8" x2="60" y2="112" />
            <circle cx="60" cy="60" r="18" />
            <path d="M8 34h20v52H8" />
            <path d="M112 34h-20v52h20" />
            <path d="M8 44a16 16 0 000 32" />
            <path d="M112 44a16 16 0 010 32" />
        </svg>
    );
}

const VARIANTS = [Basketball, HoopNet, Backboard, Megaphone, Trophy, CourtLines];

/**
 * Renders an NCAA-themed SVG overlay based on variant index.
 * @param {{ variant: number }} props
 */
export default function NcaaOverlaySvg({ variant = 0 }) {
    const Svg = VARIANTS[variant % VARIANTS.length];
    return (
        <div className="card-hover-overlay" aria-hidden="true" data-variant={variant % VARIANTS.length}>
            <Svg />
        </div>
    );
}
